import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const MealInputAction = {
    photo: 'photo',
    history: 'history',
    preset: 'preset',
    skip: 'skip',
};
export const MealInputActionIcon = ({ action, classObject }) => {
    const iconPath = `/assets/images/icons/meal_input_${action}.svg`;
    return React.createElement("img", { className: css(styles.container, classObject), src: iconPath });
};
const styles = StyleSheet.create({
    container: {
        flexShrink: 0,
        width: 20,
        height: 20,
    },
});
